import { controls, currencyToNumber, grouped } from "../../controls";


const rpdr41 = {
  label: "PACS Employee Information",
  starting: true,
  url: "daybook",
  pageLabel: "PACS Employee Information",
  pageType: "history",
  filter: [
    // ...controls.displayText({ tab: "filter", label: "Bank" }),
    // ...controls.oc({ tab: "filter", length: 4, c: "Bank", defaultVal: "assigned_bank", placeHolder: "Bank Code", name: "bank_code", fastpath: "banks" }),
    // ...controls.showData({ tab: "filter", displaytype: "capital", data: "bank_display" }),

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "PACS Employee Information",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    filterable: true,
    sortable: true,
    // defaultsTo: 0,
    pivot: true,
    extraRows: {
      location: "top",
      fields: ["gross_salary_drawn", "basic", "da", "ca", "hra", "pf", "conveyance", "special_other", "medical", "total"],
      subtotals: {
        by: "bank_name",
        displayIn: "name",
        subtotals: {
          by: "pacs_name",
          displayIn: "name",
        },
        // otherstat: [{ type: "count", label: "Count" }, { type: "avg", label: "Average", }, { type: "median", label: "Median" }], 
      },
      grandtotal: { type: "fixed", displayIn: "name", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      // {
      //   Header: "Bank Name",
      //   accessor: "bank_name",
      //   width: "*",
      // },
      // {
      //   Header: "PACS Name",
      //   accessor: "pacs_name",
      // },
      {
        Header: "Name",
        accessor: "name",
        width: 300
      },
      {
        Header: "Employment Status",
        accessor: "employment_status",
      },
      {
        Header: "Designation",
        accessor: "designation",
      },
      {
        Header: "Against Sanctioned Post",
        accessor: "is_against_sanctioned_post",
        type: "tick"
      },
      {
        Header: "DOB",
        accessor: "date_of_birth",
        type: "date"

      }, {
        Header: "Date of Joinging",
        accessor: "date_of_joining",
        type: "date"

      }, {
        Header: "Date of Retirement",
        accessor: "date_of_retirement",
        type: "date"

      },
      {
        Header: "Monthly Gross Salary as on 31/03/2022",
        accessor: "gross_salary_drawn",
        type: "currency"

      },
      {
        Header: "Salary as on 31/03/2022",
        columns: [
          {
            Header: "Basic",
            accessor: "basic",
            type: "currency"
          },
          {
            Header: "DA",
            accessor: "da",
            type: "currency"

          },
          {
            Header: "CA",
            accessor: "ca",
            type: "currency"
          },
          {
            Header: "HRA",
            accessor: "hra",
            type: "currency"
          },
          {
            Header: "PF",
            accessor: "pf",
            type: "currency"

          },
          {
            Header: "Conveyance Allowance",
            accessor: "conveyance",
            type: "currency"

          },
          {
            Header: "Special / Other Allowance",
            accessor: "special_other",
            type: "currency"

          },
          {
            Header: "Medical Allowance",
            accessor: "medical",
            type: "currency"

          },
          {
            Header: "Total Pay",
            accessor: "total",
            type: "currency"
          },
        ]
      },
      {
        Header: "Gross Salary as per staff service rules 2017",
        accessor: "is_salary_as_per_rules",
        type: "tick"
      },
      {
        Header: "BR No",
        accessor: "board_resolution_no",
      },
      {
        Header: "BR Date",
        accessor: "board_resolution_date",
        type: "date"
      },
      {
        Header: "Salary Bank",
        accessor: "salary_bank_name",
      }, {
        Header: "Account No",
        accessor: "salary_ac_no",
      }, {
        Header: "IFSC",
        accessor: "salary_ifsc_code",
      }, {
        Header: "Remarks",
        accessor: "remarks",
      },
    ]
  }
};

export default rpdr41;